<template>
  <collapsible-widget
    title="WARSTWY ORGANIZACJI"
    :maxHeight="30"
    :expand-widget="mvtLayersExpanded"
    :accordion="accordion"
    @toggled="onToggled"
    ref="collapsible"
    :default-expanded="mvtLayersExpanded"
    :selectAllEnabled="false"
    :onCheckboxChanged="onCheckboxChanged"
    :allSelected.sync="allSelected"
    :indeterminate="indeterminate">
    <composition-layers :layers="mvtLayers" @set-layer-extent="setLayerExtent"></composition-layers>
  </collapsible-widget>
</template>

<script>
import { mapGetters } from "vuex";
import CollapsibleWidget from "./CollapsibleWidget";
import CompositionLayers from "./CompositionLayers";
import { MVT_LAYERS_EXPANDED_SET, SET_LAYER_VISIBILITY } from "../store/mutations.type";

export default {
  name: "Compositions",
  props: {
    accordion: {
      type: String,
      default: 'panel'
    }
  },
  components: {
    CollapsibleWidget,
    CompositionLayers
  },
  computed: {
    ...mapGetters(["readOnly", "mvtLayersExpanded"]),
    mvtLayers() {
      return Array(...this.$store.getters.mvtLayers.sort((a, b) => { return b.order - a.order; }));
    },
    mvtLayersHasItems() {
      return this.mvtLayers.length > 0;
    },
    indeterminate() {
      return this.mvtLayers.some(l => l.visible) && this.mvtLayers.some(l => !l.visible);
    },
    allSelected() {
      return this.mvtLayers.every(l => l.visible);
    }
  },
  methods: {
    onToggled(expanded) {
      this.$emit("toggled", expanded);
      this.$store.commit(MVT_LAYERS_EXPANDED_SET, (expanded || {}).expanded);
    },
    onCheckboxChanged(value) {
      if (value) {
        this.mvtLayers.forEach(layer => {
          this.$store.commit(SET_LAYER_VISIBILITY, { layerId: layer.id, visible: true });
        });
      } else {
        this.mvtLayers.forEach(layer => {
          this.$store.commit(SET_LAYER_VISIBILITY, { layerId: layer.id, visible: false });
        });
      }
    },
    setLayerExtent(extent) {
      this.$emit("set-layer-extent", extent);
    }
  }
};
</script>
